import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Form, Modal } from "react-bootstrap";
import moment from "moment";
import { updateImoPreventionAction, getIncidentById } from "actions";

const ApproveRejectModal = ({ show, handleClose, action }) => {
  const dispatch = useDispatch();
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [imoComment, setImoComment] = useState("");

  // Load current action details into modal state
  useEffect(() => {
    if (action) {
      setApprovalStatus(action.imo_approval ?? null);
      setImoComment(action.imo_comments || "");
    }
  }, [action]);

  // Handle approve/reject and submit immediately (same as PreventiveAction)
  const handleApproval = async (status) => {
    if (!action) return;

    setApprovalStatus(status);

    const payload = [
      {
        id: action.id,
        imo_approval: status,
        imo_comments: imoComment,
      },
    ];

    await dispatch(updateImoPreventionAction(payload));

    if (action.incident_id) {
      await dispatch(getIncidentById(action.incident_id, "update"));
    }

    handleClose();
  };

  // Handle comment update (does not auto-submit until approval is clicked)
  const handleCommentChange = (value) => {
    setImoComment(value);
  };

  if (!action) return null;

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <h5 className="font-20 font-weight-s-bold heading-color">
            Preventive Action Approval
          </h5>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="p-4">
          <Row>
            <Col lg={4}>
              <h2 className="font-13 font-weight-normal heading-color">
                Proposed By:
              </h2>
              <p className="font-13 font-weight-normal text-color">
                <img
                  src="/assets/images/proposed-user.png"
                  className="me-2"
                  alt="proposer"
                />
                {action.user?.name || "N/A"}
              </p>
            </Col>

            <Col lg={4}>
              <h2 className="font-13 font-weight-normal heading-color">
                Priority Level:
              </h2>
              <p className="font-13 font-weight-normal text-color">
                {action.priority_level_name || "N/A"}
              </p>
            </Col>

            <Col lg={4}>
              <h2 className="font-13 font-weight-normal heading-color">
                Implementation Timeline:
              </h2>
              <p className="font-13 font-weight-normal text-color">
              {action.implementation_time
                                    ? moment(action.implementation_time + "Z").format(
                                        "YYYY-MM-DD HH:mm"
                                      )
                                    : "N/A"}
              </p>
            </Col>

            <Col lg={12}>
              <h2 className="font-13 font-weight-normal heading-color">
                Description:
              </h2>
              <p
                className="font-13 font-weight-normal text-color"
                dangerouslySetInnerHTML={{
                  __html: action.action_description || "N/A",
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              {action.imo_approval === null ? (
                <>
                  <Form.Label className="label-input">IMO Comments</Form.Label>
                  <Form.Control
                    className="input-field"
                    as="textarea"
                    name={`imo_comments_${action.id}`}
                    value={imoComment}
                    onChange={(e) => handleCommentChange(e.target.value)}
                    placeholder="Leave a comment here"
                    style={{ height: "100px" }}
                  />
                </>
              ) : (
                <>
                  <h2 className="font-13 font-weight-normal heading-color">
                    IMO Comments:
                  </h2>
                  <p
                    className="font-13 font-weight-normal text-color"
                    dangerouslySetInnerHTML={{
                      __html: action.imo_comments || "N/A",
                    }}
                  />
                </>
              )}
            </Col>
          </Row>
        </div>
      </Modal.Body>

      <Modal.Footer className="w-100">
        {action.imo_approval === null && (
          <div className="d-flex justify-content-end align-items-center w-100">
            {/* <h5 className="font-14 font-weight-semibold text-dark mb-0">
              IMO Approval
            </h5> */}
            <div className="d-flex gap-3">
              <button
                type="button"
                className={`approve-btn ${
                  approvalStatus === 1 ? "selected" : ""
                }`}
                onClick={() => handleApproval(1)}
              >
                <img
                  src="/assets/images/approved-tik.svg"
                  className="me-2"
                  alt="approve"
                />
                Approve
              </button>

              <button
                type="button"
                className={`reject-btn ${
                  approvalStatus === 0 ? "selected" : ""
                }`}
                onClick={() => handleApproval(0)}
              >
                <img
                  src="/assets/images/reject-cross.svg"
                  className="me-2"
                  alt="reject"
                />
                Reject
              </button>
            </div>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ApproveRejectModal;
